import React, { useState, useEffect } from "react";
import "./FlightCard.css";
import api from "../../../Api";
import { useNavigate } from "react-router-dom";
import FullscreenSpinner from "../../../Components/Helping Component/Fullscreeenspinner";

const formatTime = date =>
  new Date(date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

const formatDate = date =>
  new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });


export default function FlightCard({ item,key, index, expandedCard, toggleExpand, traceId }) {
  const segments = item?.Segments?.[0] || []; // array of segments
  const firstSegment = segments[0];
  const stopies = item?.Segments?.[0]

  const fare = item.Fare;
  const rules = item.MiniFareRules?.[0] || [];
  const [fareQoute, setFareQoute] = useState()
  const [activeTab, setActiveTab] = useState("itinerary");
  const [fareRule, setFareRule] = useState(null);
  const [fareQuote, setFareQuote] = useState(null);
  const [ruleLoading, setRuleLoading] = useState(false);

  const navigate = useNavigate();


  const totalDuration = segments.reduce(
    (sum, seg) => sum + (seg?.Duration || 0),
    0
  );
  const hours = Math.floor(totalDuration / 60);
  const minutes = totalDuration % 60;

  useEffect(() => {
    if (activeTab !== "rules") return;

    const fetchFareData = async () => {
      try {
        setRuleLoading(true);

        const [ruleRes, quoteRes] = await Promise.all([
          api.post("/flights/fare-rule", {
            ResultIndex: item?.ResultIndex,
            TraceId: traceId
          }),
          api.post("/flights/fare-quote", {
            ResultIndex: item?.ResultIndex,
            TraceId: traceId
          })
        ]);

        setFareRule(ruleRes?.data?.data);
        setFareQuote(quoteRes?.data?.data);

        console.log("the fare rules are:", ruleRes?.data?.data)
        console.log("the fare quote are ", quoteRes?.data?.data)

      } catch (err) {
        console.error("Fare rule fetch failed", err);
      } finally {
        setRuleLoading(false);
      }
    };

    fetchFareData();
  }, [activeTab, item?.ResultIndex, traceId]);


  const quotation = fareQuote?.responseData?.Response;
  const insurancePlans = quotation?.InsuranceResult?.Results || [];
  const updatedFare = quotation?.Results?.Fare;
  const updatedRules = quotation?.Results?.FareRules || [];

  const finalFareRules = fareRule?.responseData?.Response?.FareRules || [];
  const [loader,setLoader] = useState(false)

  const handleRules = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if(!accessToken){
      navigate('/signup');
      return;
    }
    setLoader(true)
    const res = await api.post("/flights/fare-rule",
      {
        ResultIndex: item?.ResultIndex,
        TraceId: traceId
      }
      
    );
    setLoader(false)
     setFareRule(res?.data?.data);
    console.log("the response from fare rules:",res.data?.data)
    const trace = res?.data?.data?.responseData?.Response?.TraceId
    console.log("trace",trace)
    navigate("/flight-checkout", { state: { carddata: item, traceId: trace,resultIndex:item?.ResultIndex } })

  }



  return (
    <div className="flight-card">
{loader  && <FullscreenSpinner/>}
      {/* ================= HEADER ================= */}
      <div className="flight-head">

        {/* Airline */}
        <div className="airline">
          <img
            src={`https://content.airhex.com/content/logos/airlines_${firstSegment.Airline.AirlineCode}_200_200_s.png`}
            alt={firstSegment.Airline.AirlineName}
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <strong>{firstSegment.Airline.AirlineName}</strong>
            <span>
              {firstSegment.Airline.AirlineCode}-{firstSegment.Airline.FlightNumber}
            </span>
          </div>
        </div>

        {/* Times */}
        <div className="flight-times">

          <div style={{ display: "flex", flexDirection: "column" }}>
            <strong>{formatTime(firstSegment.Origin.DepTime)}</strong>
            <span>{firstSegment.Origin.Airport.CityCode}</span>
          </div>

          <div className="timeline-middle">
            <span className="duration">
              {hours}h {minutes}m
            </span>

            <div className="timeline-line">
              <span className="dot start"></span>
              <span className="plane">✈</span>
              <span className="dot end"></span>
            </div>

            <span className="stop">
              {stopies.length > 1 ? "1 Stop" : "Non-stop"}
            </span>
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <strong>{formatTime(segments[1]?.Destination.ArrTime || segments[0]?.Destination.ArrTime)}</strong>
            <span>{segments[1]?.Destination.Airport.CityCode || segments[0]?.Destination.Airport.CityCode}</span>
          </div>
        </div>

        {/* Price */}
        <div className="price-box">
          <div className="price">
            ₹{fare.OfferedFare.toFixed(0)}
            <span className="old">₹{fare.PublishedFare}</span>
          </div>

          <button className="book-btn" onClick={handleRules}>Book Now</button>
          {item.IsRefundable && <small className="refund">Refundable*</small>}
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <div className="flight-footer">
        <span>
          🧳 {firstSegment.Baggage} | Cabin {firstSegment.CabinBaggage}
        </span>

        <button onClick={() => toggleExpand(index)}>
          {expandedCard === index ? "Hide Details ▲" : "View Details ▼"}
        </button>

        <span className="seats">
          {firstSegment.NoOfSeatAvailable} seats left
        </span>
      </div>

      {/* ================= EXPAND PANEL ================= */}
      {expandedCard === index && (
        <div className="expand-panel">

          {/* Tabs */}
          <div className="flight-tabs">
            {["itinerary", "baggage", "rules"].map(tab => (
              <span
                key={tab}
                className={`flight-tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab === "itinerary" && "Itinerary"}
                {tab === "baggage" && "Baggage & Fare"}
                {tab === "rules" && "Fare Rules"}
              </span>
            ))}
          </div>

          {/* ================= ITINERARY ================= */}
          {activeTab === "itinerary" && (
            <div className="timeline-wrapper">

              <div className="timeline-date">
                ✈ Depart <strong>{formatDate(firstSegment.Origin.DepTime)}</strong>
              </div>

              <div className="timeline-card">
                <div className="timeline-time left">
                  <strong>{formatTime(firstSegment.Origin.DepTime)}</strong>
                  <span>{formatDate(firstSegment.Origin.DepTime)}</span>
                  <small>{firstSegment.Origin.Airport.CityCode}</small>
                </div>

                <div className="timeline-middle">
                  <span className="duration">
                    {hours}h {minutes}m
                  </span>


                  <div className="timeline-line">
                    <span className="dot start"></span>
                    <span className="plane">✈</span>
                    <span className="dot end"></span>
                  </div>

                  <span className="stop">
                    {stopies.length > 1 ? "1 Stop" : "Non-stop"}
                  </span>
                </div>

                <div className="timeline-time right">
                  <strong>{formatTime(segments[1]?.Destination.ArrTime || segments[0]?.Destination.ArrTime)}</strong>
                  <span>{formatDate(segments[1]?.Destination.ArrTime || segments[0]?.Destination.ArrTime)}</span>
                  <small>{segments[1]?.Destination.Airport.CityCode || segments[0]?.Destination.Airport.CityCode}</small>
                </div>
              </div>
              {segments.map((seg, i) => (
                <div className="flight-info-card" key={i}>

                  <div className="airline-logo">
                    <img
                      src={`https://content.airhex.com/content/logos/airlines_${seg.Airline.AirlineCode}_200_200_s.png`}
                      alt={seg.Airline.AirlineName}
                    />
                  </div>

                  <div className="flight-info">
                    <h4>
                      {formatTime(seg.Origin.DepTime)} – {formatTime(seg.Destination.ArrTime)}
                    </h4>

                    <p className="route">
                      {seg.Origin.Airport.CityName} ({seg.Origin.Airport.CityCode})
                      {" → "}
                      {seg.Destination.Airport.CityName} ({seg.Destination.Airport.CityCode})
                    </p>

                    <p className="flight-no">
                      {seg.Airline.AirlineName} • {seg.Airline.AirlineCode}-{seg.Airline.FlightNumber}
                    </p>

                    <p className="datetime">
                      Departure: {formatDate(seg.Origin.DepTime)} {formatTime(seg.Origin.DepTime)}
                    </p>
                  </div>

                  <div className="arrival-info">
                    <span>
                      {Math.floor(seg.Duration / 60)}h {seg.Duration % 60}m
                    </span>
                    <p>
                      Arrival: {formatDate(seg.Destination.ArrTime)} {formatTime(seg.Destination.ArrTime)}
                    </p>
                  </div>

                </div>
              ))}


            </div>
          )}

          {/* ================= BAGGAGE ================= */}
          {activeTab === "baggage" && (
            <div className="tab-content">
              <p>✔ Checked Baggage: {firstSegment.Baggage}</p>
              <p>✔ Cabin Baggage: {firstSegment.CabinBaggage}</p>
              <p>✔ Base Fare: ₹{fare.BaseFare}</p>
              <p>✔ Taxes: ₹{fare.Tax}</p>
              <p>✔ Total Fare: ₹{fare.PublishedFare}</p>
            </div>
          )}



          {/* ================= RULES ================= */}
          {activeTab === "rules" && (
            <div className="tab-content fare-rules">

              {/* Loading */}
              {ruleLoading && (
                <div className="loading-box">
                  <p>⏳ Fetching fare rules...</p>
                </div>
              )}

              {/* Fare Rules from FINAL FARE RULE API */}
              {!ruleLoading && finalFareRules.length > 0 && (
                <div className="rules-section">
                  <h4 className="section-title">Fare Rules</h4>

                  {finalFareRules.map((rule, index) => (
                    <div key={index} className="rule-card">

                      {/* Header */}
                      <div className="rule-header">
                        <strong>
                          {rule.Origin} → {rule.Destination}
                        </strong>
                        <span>{rule.Airline}</span>
                      </div>


                      <p className="fare-basis">
                        <strong>Fare Basis:</strong> {rule.FareBasisCode}
                      </p>

                      {/* Fare Rule Detail (HTML from backend) */}
                      <div
                        className="fare-rule-detail"
                        dangerouslySetInnerHTML={{
                          __html: rule.FareRuleDetail
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}

              {/* Empty state */}
              {!ruleLoading && finalFareRules.length === 0 && (
                <div className="empty-state">
                  <p>Fare rules are not available for this flight.</p>
                </div>
              )}
            </div>
          )}






        </div>
      )}
    </div>
  );
}
